module.exports = __webpack_public_path__ + "images/button_make_lead.gif";